import { getJuliangOrgSyncList, uploadToMediaOrganization } from '@/api/juliang-organization'

export default {
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            loading: false,
            orgLoading: false,
            organizations: [],
            checkedIds: [],
        }
    },
    computed: {
        isAllChecked() {
            return this.organizations.length > 0 && this.checkedIds.length === this.organizations.length
        },
        isIndeterminate() {
            return this.checkedIds.length > 0 && this.checkedIds.length < this.organizations.length
        },
    },
    watch: {
        // 父组件用 v-if 渲染本组件，创建时 showForm 已为 true，
        // 需加 immediate 让 watch 在初始化时也触发，确保加载组织列表。
        showForm: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.checkedIds = []
                    this.loadOrganizations()
                }
            }
        }
    },
    methods: {
        // 加载可同步的组织列表，只展示开启同步开关的组织
        loadOrganizations() {
            this.orgLoading = true
            getJuliangOrgSyncList().then(res => {
                this.organizations = res.data.list || []
                this.orgLoading = false
            }).catch(() => {
                this.orgLoading = false
            })
        },
        handleCheckAll(e) {
            this.checkedIds = e.target.checked ? this.organizations.map(org => org.id) : []
        },
        submit() {
            if (this.checkedIds.length === 0) {
                return this.$message.warning('请至少选择一个组织')
            }

            const localMaterialIds = this.model.local_material_ids || []
            if (localMaterialIds.length === 0) {
                return this.$message.warning('请先选择素材')
            }

            this.loading = true
            uploadToMediaOrganization({
                local_material_ids: localMaterialIds,
                organize_ids: this.checkedIds,
            }).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步任务已提交')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.checkedIds = []
            this.$emit('update:showForm', false)
        }
    }
}
